import { FunctionComponent, memo } from 'react';
import { useTimer } from '../hooks';

interface IFreeCaseV2TimerProps {
  deposit24HourTtl: string;
}

export const FreeCaseV2Timer: FunctionComponent<IFreeCaseV2TimerProps> = memo(
  ({ deposit24HourTtl }) => {
    const timer = useTimer(deposit24HourTtl);

    return (
      <>
        {timer.hours}:{timer.minutes}:{timer.seconds}
      </>
    );
  },
);
